// Renders the company logo with the strongest website-side protection against
// browser image interactions (Google Lens hover, right-click "Search image",
// drag-and-drop, text/image selection). The artwork file is untouched.
// Note: Chrome's page-level Lens (right-click page -> Search with Google Lens)
// is browser-controlled and cannot be disabled by any website.
export default function ProtectedLogo({ src = "/maqline-logo.png", alt, className }) {
  const block = (e) => e.preventDefault();
  return (
    <span
      className="relative inline-block select-none"
      onContextMenu={block}
      data-testid="protected-logo"
      data-logo-protected="true"
    >
      <img
        src={src}
        alt={alt}
        className={className}
        draggable="false"
        onContextMenu={block}
        onDragStart={block}
        style={{ WebkitUserDrag: "none", userSelect: "none", pointerEvents: "none" }}
      />
      <span aria-hidden="true" className="absolute inset-0 z-10" onContextMenu={block} />
    </span>
  );
}
